import { render, staticRenderFns } from "./account.vue?vue&type=template&id=b8c9bf8c&scoped=true&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"
import style0 from "./account.vue?vue&type=style&index=0&lang=css&"
import style1 from "./account.vue?vue&type=style&index=1&id=b8c9bf8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c9bf8c",
  null
  
)

export default component.exports